import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Globe } from "lucide-react";
import { toast } from "sonner";
import GoogleButton from "@/components/GoogleButton";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 grid-bg" data-testid="login-page">
      <form onSubmit={submit} className="card-surface rounded-xl p-8 w-full max-w-md">
        <div className="flex items-center gap-2 mb-6">
          <Globe className="w-6 h-6 text-[#00F0FF]" />
          <span className="font-display font-extrabold text-lg">Sign in</span>
        </div>
        {err && <div className="mb-4 text-sm text-[#EF4444] bg-[#EF4444]/10 border border-[#EF4444]/30 rounded px-3 py-2" data-testid="login-error">{err}</div>}
        <label className="block text-sm text-[#94A3B8] mb-1">Email</label>
        <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-[#0B0F19] border border-white/10 rounded-md px-4 py-2.5 mb-4 focus:border-[#00F0FF] focus:outline-none" />
        <label className="block text-sm text-[#94A3B8] mb-1">Password</label>
        <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-[#0B0F19] border border-white/10 rounded-md px-4 py-2.5 mb-6 focus:border-[#00F0FF] focus:outline-none" />
        <button disabled={busy} data-testid="login-submit"
          className="w-full bg-[#00F0FF] text-[#04121a] font-semibold py-3 rounded-md hover:brightness-110 transition disabled:opacity-50">
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <div className="flex items-center gap-3 my-4">
          <div className="flex-1 h-px bg-white/10" />
          <span className="text-xs text-[#94A3B8]">or</span>
          <div className="flex-1 h-px bg-white/10" />
        </div>
        <GoogleButton />
        <p className="mt-4 text-sm text-[#94A3B8] text-center">
          No account? <Link to="/register" className="text-[#00F0FF]">Register</Link>
        </p>
      </form>
    </div>
  );
}
